import { initializeTabs } from "./tabs-helper";

const tabInstances = document.querySelectorAll(".tabs");

initializeTabs(tabInstances);